/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1IndividualpaymentParcelsParcelidMutationRequest,
  PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
  PutApiV1IndividualpaymentParcelsParcelidPathParams,
  PutApiV1IndividualpaymentParcelsParcelid400,
  PutApiV1IndividualpaymentParcelsParcelid401,
  PutApiV1IndividualpaymentParcelsParcelid500,
} from "../../types/individualPaymentOperationsController/PutApiV1IndividualpaymentParcelsParcelid.ts";

function getPutApiV1IndividualpaymentParcelsParcelidUrl(
  parcelId: PutApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/individualpayment/parcels/${parcelId}` as const,
  };
  return res;
}

/**
 * @description Parcela paga só atualiza nº/data da NF. Nosso Número alterado é validado contra outras parcelas e o histórico de boletos do banco. Mudança de multa/pontualidade/valor/vencimento/tipo/número volta a parcela para 'aguardando integração'; troca de método zera a data de integração; matrícula zerada é quitada. Migrado do legado IndividualPayment/EditParcel POST. **(Requer Authorization para autenticação)**
 * @summary Edita uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId}
 */
export async function putApiV1IndividualpaymentParcelsParcelid(
  parcelId: PutApiV1IndividualpaymentParcelsParcelidPathParams["parcelId"],
  data?: PutApiV1IndividualpaymentParcelsParcelidMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1IndividualpaymentParcelsParcelidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1IndividualpaymentParcelsParcelidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1IndividualpaymentParcelsParcelid400
      | PutApiV1IndividualpaymentParcelsParcelid401
      | PutApiV1IndividualpaymentParcelsParcelid500
    >,
    PutApiV1IndividualpaymentParcelsParcelidMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1IndividualpaymentParcelsParcelidUrl(
      parcelId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
